import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, Image } from "antd";
import Sider from "antd/lib/layout/Sider";
import {
  ShoppingOutlined,
  BarChartOutlined,
  UnorderedListOutlined,
  UserOutlined,
  // PoundOutlined, // Remove this import
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  GiftOutlined,
  SettingOutlined,
  TeamOutlined,
  InboxOutlined,
  CarOutlined,
  BankOutlined,
  CustomerServiceOutlined,
  TagsOutlined,
  LayoutOutlined,
  CheckSquareOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";

import "./index.css";
import black_logo from "../../assets/logo_black.png";
import white_logo from "../../assets/logo_white.png";
import titleLogo from "../../assets/logo_blacktext.png";
import whiteTitleLogo from "../../assets/logo_whitetext.png";
import { canViewSection, isOperationsOnlyRole } from "../../helpers/permissions";

export default function Sidenav({ onSideNavCollapse }) {
  const homePath = isOperationsOnlyRole() ? "/store-checklists" : "/dashboard";
  // Each role's sections come from permissions.js.
  const showSection = canViewSection;

  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [roleLoaded, setRoleLoaded] = useState(false);
  let href = window.location.href.split("/");
  href = href[3];

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    setIsDarkMode(theme === "dark");

    // Check if role is loaded
    const checkRole = () => {
      const role = localStorage.getItem("user_role_id");
      if (role) {
        setRoleLoaded(true);
      } else {
        // Retry after a short delay if role not found
        setTimeout(() => {
          const retryRole = localStorage.getItem("user_role_id");
          setRoleLoaded(true); // Set true anyway to avoid infinite loading
        }, 100);
      }
    };
    checkRole();

    // Listen for theme changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "data-theme") {
          setIsDarkMode(document.body.getAttribute("data-theme") === "dark");
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    return () => observer.disconnect();
  }, []);

  // Custom wrapper to match Ant Design icon style
  const RupeeIcon = () => (
    <span
      className="anticon"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        lineHeight: 1,
      }}
    >
      <FontAwesomeIcon
        icon={faIndianRupeeSign}
        style={{
          fontSize: "14px",
          verticalAlign: "middle",
        }}
      />
    </span>
  );

  return (
    <Sider
      className="sdb"
      collapsible
      trigger={null}
      breakpoint="lg"
      collapsedWidth={55}
      collapsed={collapsed}
      onBreakpoint={(broken) => {
        onSideNavCollapse(broken);
        setCollapsed(broken);
      }}
      onCollapse={(collapsed, type) => {
        onSideNavCollapse(collapsed);
        setCollapsed(collapsed);
      }}
    >
      <div className="lgo">
        <Link onClick={() => setActiveMenu(homePath)} to={homePath}>
          <div className="logo-container">
            {collapsed && (
              <Image
                width={40}
                src={isDarkMode ? black_logo : white_logo}
                preview={false}
                alt="RAPSAP Logo"
                style={{ borderRadius: "50%" }}
              />
            )}
            {!collapsed && (
              <Image
                width={120}
                src={isDarkMode ? titleLogo : whiteTitleLogo}
                preview={false}
                alt="Rapsap"
                className="title-logo"
              />
            )}
          </div>
        </Link>
      </div>
      {roleLoaded && (
        <Menu
          className="mnu custom-sidebar-menu"
          mode="inline"
          selectedKeys={
            activeMenu ? [activeMenu] : href ? ["/" + href] : ["/dashboard"]
          }
        >
        {showSection("dashboard") && (
          <Menu.Item
            title="Dashboard"
            key="/dashboard"
            icon={<BarChartOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/dashboard")} to="/dashboard">
              <span>Dashboard</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("users") && (
          <Menu.Item
            title="Users"
            key="/users"
            icon={<UserOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/users")} to="/users">
              <span>Users</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("products") && (
          <Menu.Item
            title="Products"
            key="/products"
            icon={<ShoppingOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/products")} to="/products">
              <span>Products</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("stock-upload") && (
          <Menu.Item
            title="Stock Upload"
            key="/stock-upload"
            icon={<UploadOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/stock-upload")} to="/stock-upload">
              <span>Stock Upload</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("orders") && (
          <Menu.Item
            title="Orders"
            key="/orders"
            icon={<UnorderedListOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/orders")} to="/orders">
              <span>Orders</span>
            </Link>
          </Menu.Item>
        )}

        {showSection("payments") && (
          <Menu.Item
            title="Payments"
            key="/payments"
            icon={<RupeeIcon />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/payments")} to="/payments">
              <span>Payments</span>
            </Link>
          </Menu.Item>
        )}

        {showSection("payment-methods") && (
          <Menu.Item
            title="Payment Methods"
            key="/payment-methods"
            icon={<BankOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/payment-methods")} to="/payment-methods">
              <span>Payment Methods</span>
            </Link>
          </Menu.Item>
        )}

        {showSection("promotions") && (
          <Menu.Item
            title="Promotions"
            key="/promotions"
            icon={<GiftOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/promotions")} to="/promotions">
              <span>Promotions</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("store-checklists") && (
          <Menu.Item
            title="Store Checklists"
            key="/store-checklists"
            icon={<CheckSquareOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/store-checklists")} to="/store-checklists">
              <span>Store Checklists</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("staff") && (
          <Menu.Item
            title="Staff"
            key="/staff"
            icon={<TeamOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/staff")} to="/staff">
              <span>Staff</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("packages") && (
          <Menu.Item
            title="Packages"
            key="/packages"
            icon={<InboxOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/packages")} to="/packages">
              <span>Packages</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("delivery") && (
          <Menu.Item
            title="Delivery"
            key="/delivery"
            icon={<CarOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/delivery")} to="/delivery">
              <span>Delivery</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("settings") && (
          <Menu.Item
            title="Settings"
            key="/settings"
            icon={<SettingOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/settings")} to="/settings">
              <span>Settings</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("instore-music") && (
          <Menu.Item
            title="Instore Music"
            key="/instore-music"
            icon={<CustomerServiceOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/instore-music")} to="/instore-music">
              <span>Instore Music</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("shelf-talker") && (
          <Menu.Item
            title="Shelf Talker"
            key="/shelf-talker"
            icon={<TagsOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/shelf-talker")} to="/shelf-talker">
              <span>Shelf Talker</span>
            </Link>
          </Menu.Item>
        )}
        {showSection("template-builder") && (
          <Menu.Item
            title="Template Builder"
            key="/template-builder"
            icon={<LayoutOutlined />}
            className="sidebar-menu-item"
          >
            <Link onClick={() => setActiveMenu("/template-builder")} to="/template-builder">
              <span>Template Builder</span>
            </Link>
          </Menu.Item>
        )}
        {/* <Menu.Item onClick={() => setActiveMenu('/reports')} title="Reports" key="7" icon={<ProfileOutlined />}>
          <Link to="/reports">
            <span>Reports</span>
          </Link>
        </Menu.Item> */}
        </Menu>
      )}
      <div
        style={{ position: "absolute", bottom: 10, left: 20 }}
        className="sidebar-collapse-icon"
      >
        {collapsed ? (
          <MenuUnfoldOutlined
            onClick={() => (onSideNavCollapse(false), setCollapsed(false))}
            style={{
              fontSize: 22,
              color: isDarkMode ? "#000000" : "#ffffff",
              cursor: "pointer",
            }}
            className="menu-icon"
          />
        ) : (
          <MenuFoldOutlined
            onClick={() => (onSideNavCollapse(true), setCollapsed(true))}
            style={{
              fontSize: 22,
              color: isDarkMode ? "#000000" : "#ffffff",
              cursor: "pointer",
            }}
            className="menu-icon"
          />
        )}
      </div>
    </Sider>
  );
}
